import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const POUListCont = styled.div((props) => ({
  marginTop:'1rem',
  // width:'80vw',
  // maxWidth:'90vw',

  '.ui.table':{
    borderWidth:0
  },

  '.ReactTable .rt-thead.-header':{
    boxShadow:'none',
    background: '#eaeff5'
  },

  '.ReactTable':{
    borderRadius:'0.5rem'
  },

  '.ReactTable .rt-thead .rt-th':{
    borderRight: 0
  },

  '.ReactTable .rt-tbody .rt-td':{
    borderRight: 0
  },

  '.-padRow':{
    cursor:'default !important'
  },

  '.ReactTable .rt-tr':{
    cursor:'pointer'
  },

  '@media only screen and (min-width: 600px)': {
    // width: '100vw',
  },

  '@media only screen and (min-width: 769px)': {
    width: '80vw',
  },

}))

export const DivText = styled.div((props) => ({
  display:'flex',
  justifyContent:`${props.left?'flex-start':props.right?'flex-end':'center'}`,

  'div.priority.urgent': {
    background: '#FF0000',
    borderRadius: '2px',
    color: '#FFF',
    fontWeight: 'bold',
    padding: '2px 5px',
  }
}))

export const GRStdCont = styled.div((props) => ({
  'div.fieldInput input:disabled':{background:'#fff !important'},
  'div.fieldInput .ui.disabled':{background:'#fff !important'},
  'div.fieldInput textarea:disabled':{background:'#fff !important'},
}))

export const GRContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  marginTop:'1rem',

  '.headerText':{
    fontWeight:'bold',
    fontSize:'1.2rem',
    color:`${v.ezMainColor}`
  },

  '.stepTitle':{
    color:`${v.ezMainColor}`,
    fontSize:'1.2rem',
    fontWeight:'bold'
  }
})

export const RowFields = styled.div({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
})
